import React, { useState } from "react";
import * as commonData from "../../../Common";
import { Link } from "react-router-dom";
import { NavItem } from "react-bootstrap";

const StatusRepeat = (props) => {
  if (props.status) {
    return (
      <>
        <tr>
          <td colSpan={3}>
            <div>
              <span
                className={`status-text status_label_details`}
                style={{
                  backgroundColor: commonData.hexToRgba(props.status.color, 0.1)
                    .backgroundColor,
                  color:
                    "#" + commonData.hexToRgba(props.status.color, 0.1).color,
                  border: `1px solid ${
                    commonData.hexToRgba(props.status.color, 0.1).borderColor
                  }`,
                }}
              >
                {" "}
                {props.status.name}
              </span>
            </div>
            <span className="status_count">{props.status.count}</span>
          </td>
          <td>
            <input
              type="checkbox"
              className="form-check-input"
              onClick={props.onCheck}
              name={props.status._id || props.status.id}
              checked={props.status.is_default}
            />
          </td>
          <td>
            <div
              class="muBtn icon-only ps-2 pe-2"
              onClick={() => props.editStatus(props.index)}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title=""
              data-bs-original-title="Edit"
            >
              <span class="svg">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </span>
            </div>
          </td>
        </tr>
      </>
    );
  }

  if (props.workflow) {
    const category = props?.workflow?.category_ids
      ?.map((itm) => {
        return itm["name"];
      })
      .join(",");

    return (
      <tr>
        <td>{commonData.firstUpper(props.workflow.workflow_name)}</td>
        <td>{category}</td>
        <td>{props.workflow.created_at || props.workflow.updated_at}</td>
        <td>
          <div
            class="muBtn icon-only ps-2 pe-2"
            onClick={() => props.editWorkflow(props.workflow.workflow_id)}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title=""
            data-bs-original-title="Edit"
          >
            <span class="svg">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </span>
          </div>

          <Link
            to={{
              pathname: `/tattle/${props.attributeset}/settings/${props.workflow.workflow_id}/manage-workflow`,
              state: props.state,
            }}
          >
            <div
              class="muBtn icon-only ps-2 pe-2"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title=""
              data-bs-original-title="Workflow"
            >
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                id="Icon"
                width="20"
                height="20"
                viewBox="0 0 20 20"
              >
                <rect
                  id="Area"
                  width="20"
                  height="20"
                  fill="#fcfcfc"
                  opacity="0"
                ></rect>
                <g
                  id="Icon-2"
                  data-name="Icon"
                  transform="translate(1.29 2.499)"
                >
                  <path
                    id="Path"
                    d="M15,10.833v5A1.667,1.667,0,0,1,13.333,17.5H4.167A1.667,1.667,0,0,1,2.5,15.833V6.667A1.667,1.667,0,0,1,4.167,5h5"
                    transform="translate(-1.29 -2.499)"
                    fill="none"
                    stroke="#3d3d3d"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.667"
                  ></path>
                  <path
                    id="Path-2"
                    data-name="Path"
                    d="M12.5,2.5h5v5"
                    transform="translate(-1.29 -2.499)"
                    fill="none"
                    stroke="#3d3d3d"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.667"
                  ></path>
                  <line
                    id="Line"
                    y1="9.167"
                    x2="9.167"
                    transform="translate(7.043 0.001)"
                    fill="none"
                    stroke="#3d3d3d"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.667"
                  ></line>
                </g>
              </svg>
            </div>
          </Link>
        </td>
      </tr>
    );
  }

  if(props.category){
    console.log("categorydd", props.category);
    return (
      <>
        <tr>
          <td colSpan={3}>
            <div>
              <span
                className={`status-text status_label_details`}
                style={{
                  backgroundColor: commonData.hexToRgba(props.category.color, 0.1)
                    .backgroundColor,
                  color:
                    "#" + commonData.hexToRgba(props.category.color, 0.1).color,
                  border: `1px solid ${
                    commonData.hexToRgba(props.category.color, 0.1).borderColor
                  }`,
                }}
              >
                {" "}
                {props.category.name}
              </span>
            </div>
            <span className="status_count">{props.category.count}</span>
          </td>
          <td>
            <div
              class="muBtn icon-only ps-2 pe-2"
              onClick={() => props.editStatus(props.index)}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title=""
              data-bs-original-title="Edit"
            >
              <span class="svg">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </span>
            </div>
          </td>
        </tr>
      </>
    );

  }
      
};

export default StatusRepeat;
